import { createFileRoute } from '@tanstack/react-router';
import FeeView from '../../../features/baseData/fees/fee/view';
import {
  createPermissionGuard,
  FEES_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gebuehren/$feeId')({
  component: FeeView,
  beforeLoad: createPermissionGuard(getPermissionSet(FEES_PERMISSIONS, 'READ')),
});

export const ViewFeeRoute = Route;
